import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";

import { Dialog } from "../../../dialog";
import { DialogFooter } from "../../../dialog-footer";
import { FormField } from "../../../form-field";
import styles from "../../filter-panel.module.scss";
import {
  SAVE_CONFIRM_LABEL,
  SAVE_DIALOG_DESCRIPTION,
  SAVE_DIALOG_TITLE,
  SAVE_NAME_LABEL,
} from "../../messages";
import type { FilterPanelSaveDialogViewProps } from "./types-save-filter-dialog";

export function FilterPanelSaveDialogView({
  visible,
  onClose,
  rest,
  className,
  testId,
  dialogTestId,
  footerTestId,
  nameTestId,
  formId,
  name,
  maxLength,
  error,
  locked,
  onNameChange,
  onSubmit,
}: FilterPanelSaveDialogViewProps) {
  return (
    <Dialog
      visible={visible}
      onHide={onClose}
      size="sm"
      showCloseIcon={false}
      locked={locked}
      data-testid={dialogTestId}
      className={classNames(styles.saveDialog, className)}
      header={SAVE_DIALOG_TITLE}
      pt={{ headerTitle: { className: "p-dialog-title-sm" } }}
      footer={
        <DialogFooter
          data-testid={footerTestId}
          testId={testId}
          confirmLabel={SAVE_CONFIRM_LABEL}
          formId={formId}
          locked={locked}
          loading={locked}
          className={styles.saveFooter}
          cancelVariant="text"
          onCancel={onClose}
        />
      }
      {...rest}
    >
      <form id={formId} noValidate className={styles.saveForm} onSubmit={onSubmit}>
        <p className={styles.saveDescription}>{SAVE_DIALOG_DESCRIPTION}</p>
        <FormField.Root testId={testId} error={error}>
          <FormField.Label>{SAVE_NAME_LABEL}</FormField.Label>
          <FormField.Control>
            <InputText
              value={name}
              maxLength={maxLength}
              aria-required
              onChange={onNameChange}
              data-testid={nameTestId}
            />
          </FormField.Control>
          <FormField.Error />
        </FormField.Root>
      </form>
    </Dialog>
  );
}
